import * as React from 'react';
import * as _ from 'underscore';

import { Messages } from '../../../codegen/Localize';
import { Location } from '../../../common/react/Location';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { ProjectDefinition } from '../../../contentDefinitions/ProjectDefinition';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ExplorerEmptyStateProps } from '../Components/ExplorerEmpyState';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface RecentsSpaceStateProps {
  readonly urls: SpacesSiteUrls;
}

export interface RecentsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export interface RecentsSpaceOwnProps {
  readonly siteName: string;
}

export type RecentsSpaceProps = RecentsSpaceStateProps & RecentsSpaceDispatchProps & RecentsSpaceOwnProps;

export class RecentsSpace extends React.PureComponent<RecentsSpaceProps> {
  public componentDidMount() {
    this.props.requestSpaceContents();
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.recentsBrowserTitle() });
  }

  public componentDidUpdate(prevProps: RecentsSpaceProps) {
    if(!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <div className={ SpaceContainerStyles.MastheadArea }>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.recentsBrowserTitle()}</div>
          </div>
        </div>
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            supportedDisplayModes={ProjectDefinition.supportedDisplayModes}
            emptyStateProps={this.emptyStateProps()}
            toolbarProps= {{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled'
            }}
          />
        </div>
      </div>
    );
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      iconUrl: imgPath('spaces_empty_recent.svg'),
      primaryMessage: Messages.recentsEmptyStatePrimary(),
      secondaryMessage: Messages.recentsEmptyStateSecondary(),
      onActionButton: this.onNoContentAction,
      actionButtonMessage: Messages.emptyStateCallToAction()
    };
  }

  private onNoContentAction = (): void => {
    Location.instance.setUrl(this.props.urls.exploreUrl());
  }
}
